<div class="relative">
  <button mat-icon-button mat-dialog-close color="primary" aria-label="Close icon"
          class="absolute top-0 right-0 scale-125">
    <mat-icon>close</mat-icon>
  </button>
</div>
<img alt="Delete blacklist item icon" src="../../../assets/figures/boy-positive.svg" class="h-[88px] mb-6 mx-auto"/>
<span mat-dialog-title class="text-3xl font-bold text-center">Biztonsan aktiválni szeretnéd?</span>
<mat-card class="flex justify-between items-center gap-x-4 rounded-2xl mat-elevation-z0 text-lg p-6 mt-6 mb-12">
  <span mat-dialog-content>{{data.name}}</span>
  <span>{{data.email}}</span>
</mat-card>
<div mat-dialog-actions class="flex justify-between gap-x-4 p-0 mb-0">
  <button mat-stroked-button mat-dialog-close color="primary" class="mol-btn-lg mol-btn-stroked-primary basis-0 grow">Mégsem</button>
  <button mat-flat-button color="primary" (click)="onActivateClicked()" class="mol-btn-lg basis-0 grow ml-0">Aktiválom</button>
</div>
